// src/components/layout/AppLayout.js
import Sidebar from './Sidebar'
import { useAuth } from '../../context/AuthContext'
import { ROLES_LABELS } from '../../lib/supabase'

export default function AppLayout({ children }) {
  const { profile } = useAuth()

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-area">
        <header className="topbar">
          <div style={{ flex: 1 }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 13, color: 'var(--dark-500)' }}>
              {ROLES_LABELS[profile?.rol] ?? ''}
            </span>
            <div style={{
              padding: '4px 12px', background: 'var(--brand-50)',
              borderRadius: 999, fontSize: 13, fontWeight: 600, color: 'var(--brand-700)',
              border: '1px solid var(--brand-200)'
            }}>
              {profile?.nombre}
            </div>
          </div>
        </header>
        <main className="page-content">
          {children}
        </main>
      </div>
    </div>
  )
}
